import React from 'react';
import PropTypes from 'prop-types';
import { InfoPopover } from '@adsk/bim360-matrix-react-components';

const IssueInfoPopover = (props) => {
  return (
    <InfoPopover className="IssueInfoPopover" tooltipClassName="IssueInfoPopover__popover-container" message={props.message}
      container={props.container} containerPadding={15}
    />
  );
};

IssueInfoPopover.displayName = 'IssueInfoPopover';

IssueInfoPopover.propTypes = {
  message: PropTypes.node.isRequired,
  container: PropTypes.object.isRequired,
};

export default IssueInfoPopover;
